import { css } from "@emotion/css";

import { Theme } from "@/modules/theme/utils/createTheme";

export const createDialogContentWrapperStyles = ({ spacing }: Theme) => ({
  contentWrapper: css({
    padding: spacing([0, 3]),
    [`@media (max-height: 700px)`]: {
      maxHeight: "80vh",
      overflowY: "auto",
    },
  }),
});
